/**
 * Десериализует 'true' в true
 */
export function stringToBoolean(value: string | null | undefined) {
  return value === 'true'
}

export function booleanToString(value: boolean) {
  return String(value)
}
